import moment from 'moment';
let content_blocks = require('../contents');

export function init(){
    
    $('#edit_program_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_program').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_program_modal').on('show.bs.modal', function (event) {

        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="show_horas"]').prop('checked', block.attr('data-show-horas') == "true" ? true : false);
        modal.find('[name="show_area"]').prop('checked', block.attr('data-show-area') == "true" ? true : false);
        modal.find('[name="show_type"]').prop('checked', block.attr('data-show-type') == "true" ? true : false);

        modal.find('[name="show_sesion"]').prop('checked', block.attr('data-show-sesion') == "true" ? true : false);
        change_show_sesion(modal, block);

        modal.find('[name="show_details_info"]').prop('checked', block.attr('data-show-details-info') == "true" ? true : false);
        change_details_info(modal, block);

        change_user_info(modal, block);

        let select_days = modal.find('[name="days[]"]');
        // select_days.val(null).trigger('change');
        let days = JSON.parse(block.attr('data-days'));

        if (typeof days == 'object' && days.length > 0) {
            days.forEach(element => {
                select_days.find('option[value="'+ element +'"]').prop('selected', true);
            });
            select_days.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
        }

        let select_rooms = modal.find('[name="rooms[]"]');
        let rooms = JSON.parse(block.attr('data-rooms'));
        if (typeof rooms == 'object' && rooms.length > 0) {
            rooms.forEach(element => {
                select_rooms.find('option[value=\''+element+'\']').prop('selected', true);
            })

            select_rooms.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
        }

        let select_tipos_sesion = modal.find('[name="tipos[]"]');
        let tipos = JSON.parse(block.attr('data-tipos'));
        if (typeof tipos == 'object' && tipos.length > 0) {
            tipos.forEach(element => {
                select_tipos_sesion.find('option[value=\''+element+'\']').prop('selected', true);
            })

            select_tipos_sesion.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
        }

        let select_areas_tematicas = modal.find('[name="areas[]"]');
        let areas = JSON.parse(block.attr('data-areas'));
        if (typeof areas == 'object' && areas.length > 0) {
            areas.forEach(element => {
                select_areas_tematicas.find('option[value=\''+element+'\']').prop('selected', true);
            })

            select_areas_tematicas.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
        }

        let select_program_type = modal.find('[name="program_type"]');
        select_program_type.find('option[value="'+ block.attr('data-program-type') +'"]').prop('selected', true);
        select_program_type.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

    });

    $('#edit_program').on('submit', function (e) {

        e.preventDefault();

        let block = $('#'+ $(this).find('[name="block_id"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        
        let days = $(this).find('[name="days[]"]').val();

        let rooms = $(this).find('[name="rooms[]"]').val();

        let tipos_sesion = $(this).find('[name="tipos[]"]').val();

        let areas_tematicas = $(this).find('[name="areas[]"]').val();

        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));

        block.attr('data-program-type', $(this).find('[name="program_type"]').val());
        block.attr('data-days', JSON.stringify(days));
        block.attr('data-rooms', JSON.stringify(rooms));
        block.attr('data-tipos', JSON.stringify(tipos_sesion));
        block.attr('data-areas', JSON.stringify(areas_tematicas));

        block.attr('data-show-horas', $(this).find('[name="show_horas"]').prop('checked'));
        block.attr('data-show-area', $(this).find('[name="show_area"]').prop('checked'));
        block.attr('data-show-type', $(this).find('[name="show_type"]').prop('checked'));
        
        block.attr('data-show-sesion', $(this).find('[name="show_sesion"]').prop('checked'));
        block.attr('data-show-sesion-title', $(this).find('[name="show_sesion_title"]').prop('checked'));
        block.attr('data-show-sesion-description', $(this).find('[name="show_sesion_description"]').prop('checked'));
        block.attr('data-show-sesion-area', $(this).find('[name="show_sesion_area"]').prop('checked'));
        block.attr('data-show-sesion-type', $(this).find('[name="show_sesion_type"]').prop('checked'));
        block.attr('data-show-sesion-link', $(this).find('[name="show_sesion_link"]').prop('checked'));
        block.attr('data-show-sesion-medias', $(this).find('[name="show_sesion_medias"]').prop('checked'));
        block.attr('data-show-moderators', $(this).find('[name="show_moderators"]').prop('checked'));

        block.attr('data-show-details-info', $(this).find('[name="show_details_info"]').prop('checked'));
        block.attr('data-show-details-horas', $(this).find('[name="show_details_horas"]').prop('checked'));
        block.attr('data-show-details-title', $(this).find('[name="show_details_title"]').prop('checked'));
        block.attr('data-show-details-description', $(this).find('[name="show_details_description"]').prop('checked'));
        block.attr('data-show-details-link', $(this).find('[name="show_details_link"]').prop('checked'));
        block.attr('data-show-details-medias', $(this).find('[name="show_details_medias"]').prop('checked'));
        block.attr('data-show-authors', $(this).find('[name="show_authors"]').prop('checked'));

        block.attr('data-show-users-photo', $(this).find('[name="show_users_photo"]').prop('checked'));
        block.attr('data-show-users-position', $(this).find('[name="show_users_position"]').prop('checked'));
        block.attr('data-show-users-work-place', $(this).find('[name="show_users_work_place"]').prop('checked'));
        block.attr('data-show-users-title', $(this).find('[name="show_users_title"]').prop('checked'));
        
        content_blocks.change_visible_button_blocks(block);
        change_view(block);
        let modal = $(this).closest('.modal');
        modal.modal('hide');

    });

    $('#edit_program input[name="show_sesion"]').on('click',function() {
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        let block = $('#'+block_id);
        change_show_sesion(modal, block);
    });

    $('#edit_program input[name="show_details_info"]').on('click',function() {
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        let block = $('#'+block_id);
        change_details_info(modal, block);
    });

    $('#edit_program input[name="show_moderators"]').on('click',function() {
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        let block = $('#'+block_id);
        change_user_info(modal, block);
    });

    $('#edit_program input[name="show_authors"]').on('click',function() {
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        let block = $('#'+block_id);
        change_user_info(modal, block);
    });

    $('.block[data-type="program"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

function change_show_sesion(modal, block){
    
    let show_sesion = modal.find('input[name="show_sesion"]').prop('checked');

    // let disabled = show_sesion == true ? false : true;

    let show_sesion_title = modal.find('input[name="show_sesion_title"]');
    let show_sesion_description = modal.find('input[name="show_sesion_description"]');
    let show_sesion_area = modal.find('input[name="show_sesion_area"]');
    let show_sesion_type = modal.find('input[name="show_sesion_type"]');
    let show_sesion_link = modal.find('input[name="show_sesion_link"]');
    let show_sesion_medias = modal.find('input[name="show_sesion_medias"]');
    let show_moderators = modal.find('input[name="show_moderators"]');
    let show_details_info = modal.find('input[name="show_details_info"]');

    // show_sesion_title.attr('disabled', disabled);
    // show_sesion_description.attr('disabled', disabled);
    // show_sesion_area.attr('disabled', disabled);
    // show_sesion_type.attr('disabled', disabled);
    // show_sesion_link.attr('disabled', disabled);
    // show_sesion_medias.attr('disabled', disabled);
    // show_moderators.attr('disabled', disabled);
    // show_details_info.attr('disabled', disabled);

    show_sesion_title.prop('checked', block.attr('data-show-sesion-title') == "true") ? true : false;
    show_sesion_description.prop('checked', block.attr('data-show-sesion-description') == "true" ? true : false);
    show_sesion_area.prop('checked', block.attr('data-show-sesion-area') == "true" ? true : false);
    show_sesion_type.prop('checked', block.attr('data-show-sesion-type') == "true" ? true : false);
    show_sesion_link.prop('checked', block.attr('data-show-sesion-link') == "true" ? true : false);
    show_sesion_medias.prop('checked', block.attr('data-show-sesion-medias') == "true" ? true : false);
    show_moderators.prop('checked', block.attr('data-show-moderators') == "true" ? true : false);
    show_details_info.prop('checked', block.attr('data-show-details-info') == "true" ? true : false);

    change_user_info(modal, block);
    change_details_info(modal, block);
}

function change_details_info(modal, block){
    
    let show_details_info = modal.find('input[name="show_details_info"]').prop('checked');

    let disabled = show_details_info == true ? false : true;

    let show_details_horas = modal.find('input[name="show_details_horas"]');
    let show_details_title = modal.find('input[name="show_details_title"]');
    let show_details_description = modal.find('input[name="show_details_description"]');
    let show_details_link = modal.find('input[name="show_details_link"]');
    let show_details_medias = modal.find('input[name="show_details_medias"]');
    let show_authors = modal.find('input[name="show_authors"]');

    show_details_horas.attr('disabled', disabled);
    show_details_title.attr('disabled', disabled);
    show_details_description.attr('disabled', disabled);
    show_details_link.attr('disabled', disabled);
    show_details_medias.attr('disabled', disabled);
    show_authors.attr('disabled', disabled);

    show_details_horas.prop('checked', disabled ? false : (block.attr('data-show-details-horas') == "true" ? true : false));
    show_details_title.prop('checked', disabled ? false : (block.attr('data-show-details-title') == "true" ? true : false));
    show_details_description.prop('checked', disabled ? false : (block.attr('data-show-details-description') == "true" ? true : false));
    show_details_link.prop('checked', disabled ? false : (block.attr('data-show-details-link') == "true" ? true : false));
    show_details_medias.prop('checked', disabled ? false : (block.attr('data-show-details-medias') == "true" ? true : false));
    show_authors.prop('checked', disabled ? false : (block.attr('data-show-authors') == "true" ? true : false));
    if(show_authors.prop('checked') == false){
        change_user_info(modal, block);
    }
}

function change_user_info(modal, block){
    let show_moderators = modal.find('input[name="show_moderators"]').prop('checked');
    let show_authors = modal.find('input[name="show_authors"]').prop('checked');

    let disabled = (show_authors == true || show_moderators == true) ? false : true;

    let show_users_photo = modal.find('input[name="show_users_photo"]');
    let show_users_position = modal.find('input[name="show_users_position"]');
    let show_users_work_place = modal.find('input[name="show_users_work_place"]');
    let show_users_title = modal.find('input[name="show_users_title"]');

    show_users_photo.attr('disabled', disabled);
    show_users_position.attr('disabled', disabled);
    show_users_work_place.attr('disabled', disabled);
    show_users_title.attr('disabled', disabled);

    show_users_photo.prop('checked', disabled ? false : (block.attr('data-show-users-photo') == "true" ? true : false));
    show_users_position.prop('checked', disabled ? false : (block.attr('data-show-users-position') == "true" ? true : false));
    show_users_work_place.prop('checked', disabled ? false : (block.attr('data-show-users-work-place') == "true" ? true : false));
    show_users_title.prop('checked', disabled ? false : (block.attr('data-show-users-title') == "true" ? true : false));
}

function change_view(block){

    block.find('li[show="type"]').html(window.program_types[block.attr('data-program-type')]);

    let days = "";
    let days_array = JSON.parse(block.attr('data-days'));
    days_array.forEach(element => {
        let day = new Date(element);
        day = moment(day).format('DD/MM/yyyy');
        days += "<li>" + day + "</li>";
    });
    block.find('ul[show="days"]').html(days);

    let rooms = "";
    let rooms_array = JSON.parse(block.attr('data-rooms'));
    rooms_array.forEach(function(element, index) {
        element = $('<textarea />').html(element).text();
        let room_obj = JSON.parse(element);
        rooms += "<li>" + Object.values(room_obj)[0] + "</li>";
    });
    block.find('ul[show="rooms"]').html(rooms);

    let tipos_sesion = "";
    let tipos_sesion_array = JSON.parse(block.attr('data-tipos'));
    tipos_sesion_array.forEach(function(element, index) {
        element = $('<textarea />').html(element).text();
        let tipo_sesion_obj = JSON.parse(element);
        tipos_sesion += "<li>" + Object.values(tipo_sesion_obj)[0] + "</li>";
    });
    block.find('ul[show="tipos"]').html(tipos_sesion);

    let areas_tematicas = "";
    let areas_tematicas_array = JSON.parse(block.attr('data-areas'));
    areas_tematicas_array.forEach(function(element, index) {
        element = $('<textarea />').html(element).text();
        let area_tematica_obj = JSON.parse(element);
        areas_tematicas += "<li>" + Object.values(area_tematica_obj)[0] + "</li>";
    });
    block.find('ul[show="areas"]').html(areas_tematicas);

    block.find('li[show="show_horas"]').attr('class', block.attr('data-show-horas') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_area"]').attr('class', block.attr('data-show-area') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_type"]').attr('class', block.attr('data-show-type') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion"]').attr('class', block.attr('data-show-sesion') == "true" ? '' : 'program_hidden');

    block.find('li[show="show_sesion_title"]').attr('class', block.attr('data-show-sesion-title') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion_description"]').attr('class', block.attr('data-show-sesion-description') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion_area"]').attr('class', block.attr('data-show-sesion-area') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion_type"]').attr('class', block.attr('data-show-sesion-type') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion_link"]').attr('class', block.attr('data-show-sesion-link') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_sesion_medias"]').attr('class', block.attr('data-show-sesion-medias') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_moderators"]').attr('class', block.attr('data-show-moderators') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_info"]').attr('class', block.attr('data-show-details-info') == "true" ? '' : 'program_hidden');

    block.find('li[show="show_details_horas"]').attr('class', block.attr('data-show-details-horas') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_title"]').attr('class', block.attr('data-show-details-title') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_description"]').attr('class', block.attr('data-show-details-description') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_link"]').attr('class', block.attr('data-show-details-link') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_medias"]').attr('class', block.attr('data-show-details-medias') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_authors"]').attr('class', block.attr('data-show-authors') == "true" ? '' : 'program_hidden');

    block.find('li[show="show_users_photo"]').attr('class', block.attr('data-show-users-photo') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_users_title"]').attr('class', block.attr('data-show-users-title') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_users_position"]').attr('class', block.attr('data-show-users-position') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_users_work_place"]').attr('class', block.attr('data-show-users-work-place') == "true" ? '' : 'program_hidden');

}